module.exports = __webpack_public_path__ + "img/ic_gold_default.06a47755.png";